$('.frame-type-mask_ce_img_with_popup button').on('click',function () {
    if (window.matchMedia("(min-width: 1400px)").matches) {
        var popup = $(this).parent().next();
        popup.toggleClass('show');
        if (popup.find('.popup-content').height() > popup.height()){
            popup.addClass('overflow-scroll')
        }
    }
});

$('.frame-type-mask_ce_img_with_popup .popup-close').on('click',function () {
    if (window.matchMedia("(min-width: 1400px)").matches) {
        $(this).parent().toggleClass('show');
    }
});

initMobileSlider();


function initMobileSlider(){
    if (window.matchMedia("(min-width: 1400px)").matches) {
        $('.frame-type-mask_ce_img_with_popup .slick-slider.mobile-slider').slick('unslick');
    }else {
        $('.frame-type-mask_ce_img_with_popup .mobile-slider:not(.slick-slider)').slick({
            infinite:false,
            adaptiveHeight: true,
            prevArrow:'<button type="button" class="slick-prev"><img alt="prev arrow" src="typo3conf/ext/st3r_template/Resources/Public/Images/pfeil_weiter.svg" width="25" height="75"></button>',
            nextArrow:'<button type="button" class="slick-next"><img alt="next arrow" src="typo3conf/ext/st3r_template/Resources/Public/Images/pfeil_weiter.svg" width="25" height="75"></button>',
        });
    }
}

window.addEventListener('resize', function(event) {
    initMobileSlider();

    $('.frame-type-mask_ce_img_with_popup button').on('click',function () {
        if (window.matchMedia("(min-width: 1400px)").matches) {
            var popup = $(this).parent().next();
            popup.toggleClass('show');
            if (popup.find('.popup-content').height() > popup.height()){
                popup.addClass('overflow-scroll')
            }
        }
    });

    $('.frame-type-mask_ce_img_with_popup .popup-close').on('click',function () {
        if (window.matchMedia("(min-width: 1400px)").matches) {
            $(this).parent().toggleClass('show');
        }
    });
});

